module.exports = __webpack_public_path__ + "static/media/10027.cfded485.jpg";